module.exports = __webpack_public_path__ + "img/PH-login.6cdd0453.jpg";